export const languageElements = {
  items: {
    "flush-filter": {
      hu: "Adatok előszűrése",
      de: "Daten filtern",
      en: "Filtering data",
    },

    "flush-data": {
      hu: "Raktári készletek",
      de: "Bestandsliste",
      en: "List of Stocks",
    },
    "field-Raktarberlo": {
      hu: "Raktárbérlő",
      de: "Kunde",
      en: "Renter",
    },
    "field-Cikkszam": {
      hu: "Cikkszám",
      de: "Artikelnummer",
      en: "Item no.",
    },
    "field-Megnevezes": {
      hu: "Megnevezés",
      de: "Bezeichnung",
      en: "Item description",
    },
    "field-Sarzs": {
      hu: "Sarzs",
      de: "LOT",
      en: "LOT",
    },
    "field-Lejarat": {
      hu: "Lejárati dátum",
      de: "MHD",
      en: "Expire date",
    },
    "field-Keszlet": {
      hu: "Készlet",
      de: "Bestand",
      en: "Stock",
    },
    "field-Csomagolas": {
      hu: "Csomagolás",
      de: "Verpackung",
      en: "Packaging",
    },

    "field-externalSystemId": {
      hu: "External System ID",
      de: "External System ID",
      en: "External System ID",
    },

    "field-PartnerId": {
      hu: "Partner ID",
      de: "Partner ID",
      en: "Partner ID",
    },
  },
};
